"use client";
import { Show } from "@chakra-ui/react";
import Link from "next/link";
import React from 'react';

import Image from "@/app/_components/Image";
import { assetsUri } from "@/services/api.service";
import { UsedCarPromotionTile } from "@/types/used-cars/used-cars.types";
import { directusImageLoader } from "@/utils/loaders";

import styles from "./promotion-tile.module.scss";

export const PromotionTile: React.FC<{
  promotion: UsedCarPromotionTile;
}> = ({ promotion }) => {
  if (!promotion.id) return null;

  const href = promotion.link_source === 'external'
  ? promotion.external_url
  : promotion.slug
    ? `/${promotion.slug}`
    : "#";

  return (
    <>
      <Show breakpoint="(min-width: 576px)">
        <Link 
          href={href}
          className={styles.promotionCardLink}
          prefetch={false}>
          <div className={styles.promotionCard}>
              <Image
                src={`${assetsUri}/${promotion.image}`}
                loader={directusImageLoader}
                className={styles.promotionCardImage}
                width={400}
                height={430}
                alt={
                    promotion.title ||
                    'Used Car Promotion'
                }
                title={
                    promotion.title ||
                    'Used Car Promotion'
                }
                loading="lazy"
                quality={30}
                sizes="(max-width:768px) 100vw, 33vw"
              />
          </div>
        </Link>
      </Show>
      <Show breakpoint="(max-width: 575px)">
        <Link 
          href={href}
          className={styles.promotionCardLink}
          prefetch={false}
        >
            <div className={styles.promotionCard}>
              <Image
                src={`${assetsUri}/${promotion.image}`}
                loader={directusImageLoader}
                className={styles.promotionCardImage}
                width={400}
                height={430}
                alt={
                    promotion.title ||
                    'Used Car Promotion'
                }
                title={
                    promotion.title ||
                    'Used Car Promotion'
                }
                loading="lazy"
                quality={30}
                sizes="(max-width:768px) 100vw, 33vw"
              />
          </div>
        </Link>
      </Show>
    </>
  );
};
